<template lang="html">
  <div class="main" v-if="show.other === 'account'">
    <div class="name">
      <div class="title">{{message.Sl192}}</div>
      <i class="material-icons close" @click="close">close</i>
    </div>
    <div class="box">
      <comp-info></comp-info>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompInfo from '@/components/other/account/info.vue'
export default {
  computed: {
    ...mapGetters({
      show: 'show'
    })
  },
  components: {
    CompInfo
  },
  data () {
    return {
      message: {
        Sl192: this.$lang.ui.notice.l192
      }
    }
  },
  mounted () {
    if (this.show.other !== 'account') {
    }
  },
  methods: {
    close () {
      this.$store.dispatch('showOther', '')
    }
  }
}
</script>

<style scoped lang="css">
.main {
  position: fixed;
  top: 10%;
  width: 760px;
  left: 50%;
  height: 80%;
  max-height: 560px;
  margin-left: -380px;
  background-color: #f0f0f0;
  -webkit-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}
.name {
  width: 100%;
  height: 50px;
}
.close {
  float: right;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.left {
  float: left;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.title {
  display: block;
  height: 100%;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.box {
  position: absolute;
  width: 100%;
  bottom: 0;
  top: 50px;
}
.ticket-more {
  width: 100%;
  padding: 20px;
}
.cell {
  background-color: #fff;
  border-radius: 2px;
  padding: 30px 55px;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
}
.bottom-button {
  text-align: right;
  width: 100%;
  padding: 25px;
}
</style>
